import { render, staticRenderFns } from "./ImpresionArqueo.vue?vue&type=template&id=0257fa00&scoped=true&"
import script from "./ImpresionArqueo.vue?vue&type=script&lang=js&"
export * from "./ImpresionArqueo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257fa00",
  null
  
)

export default component.exports